
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/solar-financing-operating-system",
      function () {
        return require("private-next-pages/features/solar-financing-operating-system.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/solar-financing-operating-system"])
      });
    }
  